import { getBaseApi } from "../api";
import type { Project, Filter } from "../types";

const api = getBaseApi();

export const createProject = async (data: Project) => {
  return api.post('/projects', data);
};

export const getProjects = async (filter: Filter) => {
  const searchParams = new URLSearchParams();
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });
  const response = await api.get(`/projects?${searchParams.toString()}`);
  return response.data;
};

export const getProject = async (id: string) => {
  const response = await api.get(`/projects/${id}`);
  return response.data?.data;
};

export const updateProject = async (id: string, data: Partial<Project>) => {
  return api.put(`/projects/${id}`, data);
};

export const deleteProject = async (id: string) => {
  return api.delete(`/projects/${id}`);
};